import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import { ImagePlaceholder } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import { ImageRoot } from "./styles";
import { ALT_IMG, IMG } from "../../constants";
import { useProduct } from "../../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
export var ProductImage = function ProductImage() {
  var _images$at;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useProduct = useProduct(),
    code = _useProduct.code,
    image = _useProduct.image,
    name = _useProduct.name;
  if (!image) {
    return /*#__PURE__*/_jsx(ImagePlaceholder, {
      testId: "".concat(getTestId(ALT_IMG), "-").concat(code)
    });
  }
  var imagesVariants = {
    url: image,
    backgroundColor: '#f5f5f5',
    params: [{
      width: 231,
      height: 231,
      quality: 90
    }, {
      width: 328,
      height: 328,
      quality: 50
    }, {
      width: 480,
      height: 480,
      quality: 50
    }, {
      width: 567,
      height: 567,
      quality: 40
    }, {
      width: 720,
      height: 720,
      quality: 35
    }, {
      width: 896,
      height: 896,
      quality: 30
    }]
  };
  var images = getImageVariants(imagesVariants);
  return /*#__PURE__*/_jsx(ImageRoot, {
    alt: name,
    className: "imageZoom",
    "data-testid": "".concat(getTestId(IMG), "-").concat(code),
    loading: "lazy",
    sizes: "(max-width: 479px) calc(47.5vw - 7.5px), (max-width: 767px) calc(31.667vw - 10px), (max-width: 919px) calc(32.031vw - 10px), (max-width: 1023px) calc(24.023vw - 15px), 231px",
    src: (_images$at = images.at(-1)) === null || _images$at === void 0 ? void 0 : _images$at.url,
    srcSet: generateSrcSet(images)
  });
};
export default ProductImage;
//# sourceMappingURL=ProductImage.js.map